var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialog.title,
        visible: _vm.dialog.visible,
        center: true,
        width: "680px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.dialog, "visible", $event)
        },
        "before-close": _vm.handleBeforeClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            disabled: _vm.dialog.loading,
            "label-width": "240px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "资源组", prop: "groupCode" } },
            [
              _c("DynamicResource", {
                attrs: { singleSelect: "1" },
                model: {
                  value: _vm.form.groupCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "groupCode", $$v)
                  },
                  expression: "form.groupCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "命中渠道", prop: "appid" } },
            [
              _c("DynamicOption", {
                attrs: { singleSelect: "1", placeholder: "请选择渠道" },
                model: {
                  value: _vm.form.appid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appid", $$v)
                  },
                  expression: "form.appid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户标签", prop: "userTag" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "请选择用户标签" },
                  model: {
                    value: _vm.form.userTag,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "userTag", $$v)
                    },
                    expression: "form.userTag",
                  },
                },
                _vm._l(_vm.options.userTag, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户类型", prop: "userType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { placeholder: "请选择用户类型" },
                  model: {
                    value: _vm.form.userType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "userType", $$v)
                    },
                    expression: "form.userType",
                  },
                },
                _vm._l(_vm.options.userType, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户id (uuid)", prop: "uuid" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请输入用户 uuid" },
                model: {
                  value: _vm.form.uuid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "uuid", $$v)
                  },
                  expression: "form.uuid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "设备id (uid)", prop: "uid" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请输入设备 uid" },
                model: {
                  value: _vm.form.uid,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "uid", $$v)
                  },
                  expression: "form.uid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "应用版本", prop: "cv" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请输入应用版本, 正整数" },
                model: {
                  value: _vm.form.cv,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cv", $$v)
                  },
                  expression: "form.cv",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "SDK 版本号", prop: "sdkCv" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: {
                  placeholder: "如 60131-39505（原始格式，自动取 - 后段）",
                },
                model: {
                  value: _vm.form.sdkCv,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sdkCv", $$v)
                  },
                  expression: "form.sdkCv",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: {}, attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.hide } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "primary",
                "native-type": "submit",
                loading: _vm.dialog.loading,
              },
              on: { click: _vm.handleQuery },
            },
            [_vm._v("发起查询")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "24px" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 6,
                  autosize: { minRows: 6, maxRows: 6 },
                },
                model: {
                  value: _vm.queryResult,
                  callback: function ($$v) {
                    _vm.queryResult = $$v
                  },
                  expression: "queryResult",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }